import {generateUUIDv4} from "../../../utils/functions/generateRandomId";

export const addAddressBook = (data) => {

    addressBooksJson.payload[0].push(
        {
            "id": generateUUIDv4(),
            "name": data.name,
            "firstName":data.firstName,
            "lastName": data.lastName,
            "nationalCode": data.nationalCode,
            "city": data.city,
            "address": data.address,
            "plate": null,
            "unit": null,
            "phone": data.phone,
            "latitude": data.latitude,
            "longitude": data.longitude,
            "postalCode": data.postalCode,
            "default": false,
            "isGatewayAddress": false
        })

}
export const updateAddressBook = (id, data) => {
    addressBooksJson.payload[0].map(((item) => {
        if (item.id.toString() === id) {
            item.default = data.default
            item.city = data.city
            item.cityCode = data.cityCode
            item.address = data.address
            item.firstName = data.firstName
            item.lastName = data.lastName
            item.latitude = data.latitude
            item.longitude = data.longitude
            item.name = data.name
            item.nationalCode = data.nationalCode
            item.phone = data.phone
            item.postalCode = data.postalCode

        }
    }))
    console.log('addressBooksJson.payload[0]',addressBooksJson.payload[0])

}
export const deleteAddressBook = (id) => {
    const newList = addressBooksJson.payload[0].filter((item) => item.id.toString() !== id)
    addressBooksJson.payload[0] = newList
}
export const deleteAddressBookJson={
    "payload": [],
    "message": "success"
}
export const updateAddressBookJson = {
    "payload": [
        {
            "id": 33,
            "name": "تست",
            "firstName": "تست",
            "lastName": "تست",
            "nationalCode": "1080468919",
            "city": "2301",
            "address": "تست",
            "plate": null,
            "unit": null,
            "phone": "09103503352",
            "latitude": 35.699326899698,
            "longitude": 51.35232925415,
            "postalCode": "8513734561",
            "default": true,
            "isGatewayAddress": false
        }
    ],
    "message": "success"
}
export const addressBooksJson = {
    "payload": [
        [
            {
                "id": 8675,
                "name": "محمد ایرانی",
                "firstName": "محمد",
                "lastName": "ایرانی",
                "nationalCode": "",
                "city": "2301",
                "address": "خیابان حجاب،کوچه سیزدهم،پلاک 9",
                "plate": null,
                "unit": null,
                "phone": "09053402004",
                "latitude": null,
                "longitude": null,
                "postalCode": "1955753961",
                "default": false,
                "isGatewayAddress": false
            },
            {
                "id": 8676,
                "name": "مریم اسدی",
                "firstName": "مریم",
                "lastName": "اسدی",
                "nationalCode": "",
                "city": "0707",
                "address": "خیابان شریعتی،خیابان پانزدهم،کوچه بیستم،پلاک41",
                "plate": null,
                "unit": null,
                "phone": "09053562885",
                "latitude": null,
                "longitude": null,
                "postalCode": "1111111111",
                "default": false,
                "isGatewayAddress": false
            },
            {
                "id": 8972,
                "name": "ایرانی",
                "firstName": "محدثه",
                "lastName": "ایرانی",
                "nationalCode": "",
                "city": "2301",
                "address": "استان تهران،تهران،خیابان اجاره دار،کوچه شایقی،،بن بست کمال پور",
                "plate": null,
                "unit": null,
                "phone": "09300183181",
                "latitude": null,
                "longitude": null,
                "postalCode": "1921481221",
                "default": true,
                "isGatewayAddress": false
            },
            {
                "id": 8973,
                "name": "شقایق محبی",
                "firstName": "شقایق",
                "lastName": "محبی",
                "nationalCode": "",
                "city": "2301",
                "address": "خیابان کاج - کوچه یکم - پلاک 427 - طبقه 3 - واحد 32",
                "plate": null,
                "unit": null,
                "phone": "09053402004",
                "latitude": null,
                "longitude": null,
                "postalCode": "1777747673",
                "default": false,
                "isGatewayAddress": false
            },
            {
                "id": 8974,
                "name": "امینی",
                "firstName": "محمد",
                "lastName": "امینی",
                "nationalCode": "",
                "city": "2301",
                "address": "خیابان شریعتی،خیابان دولت،کوچه دهم،پلاک22،واحد9",
                "plate": null,
                "unit": null,
                "phone": "09053562885",
                "latitude": null,
                "longitude": null,
                "postalCode": "1581735418",
                "default": false,
                "isGatewayAddress": false
            },
            {
                "id": 9667,
                "name": "تهران",
                "firstName": "شقایق",
                "lastName": "تست",
                "nationalCode": "",
                "city": "2301",
                "address": "خیابان ایرانشهر/کوچه دهخدا شرقی/جنب هتل سروش/پلاک ۴۸/ شرکت پادرو",
                "plate": null,
                "unit": null,
                "phone": "09912503845",
                "latitude": null,
                "longitude": null,
                "postalCode": "1111111111",
                "default": false,
                "isGatewayAddress": false
            },
            {
                "id": 10006,
                "name": "پادرو",
                "firstName": "پشوتن",
                "lastName": "پورپزشک",
                "nationalCode": null,
                "city": "2301",
                "address": "خیابان ایرانشهر، علامه دهخدا شرقی، پلاک 48، شرکت پادرو",
                "plate": null,
                "unit": null,
                "phone": "09396863577",
                "latitude": "35.699739",
                "longitude": "51.338097",
                "postalCode": "1581643714",
                "default": false,
                "isGatewayAddress": false
            }
        ]
    ],
    "message": "success"
}